import { SaleTag } from "interfaces";
import { getSaleTags } from "./thunks";
import { RootState } from "redux/store";
import { initialState } from "./initial-state";
import { PayloadAction, createSlice, current } from "@reduxjs/toolkit";
import {
	PREFIX,
	setStickyLocalStorage,
	LS_DOT_MEGAMENU_HIDDEN_AT
} from "./helper";
import { sortByPriority } from "utils/sort";

interface HideHamburgerDotPayload {
	id: SaleTag["id"];
	hiddenAt: string;
}

export const stickySaleTagSlice = createSlice({
	name: PREFIX,
	initialState,
	reducers: {
		setActiveTags: (state, action: PayloadAction<SaleTag[]>) => {
			state.activeTags = action.payload;
		},
		closeStickyTag: (state, action: PayloadAction<string>) => {
			const stickyId = action.payload;
			setStickyLocalStorage(stickyId);
			state.closedStickyTags = [...state.closedStickyTags, action.payload];
		},
		showHamburgerDot: (state) => {
			state.showMegaMenuIndicator = true;
		},
		hideHamburgerDot: (
			state,
			action: PayloadAction<HideHamburgerDotPayload | undefined>
		) => {
			const payload = action.payload;
			if (typeof payload === "undefined") {
				state.showMegaMenuIndicator = false;
				return;
			}
			const { id, hiddenAt } = payload;
			const { closedMenuSaleTags, activeTags } = current(state);
			if (closedMenuSaleTags.includes(id)) {
				return;
			}
			const tagsOnMegaMenu = activeTags.filter((tag) => tag.showMegaMenuTag);
			// Only the highest-priority tag is displayed for each mega menu section.
			const visibleTagsOnMegaMenu = tagsOnMegaMenu.filter(
				(tag, index) =>
					tagsOnMegaMenu.findIndex(
						(item) => item.megaMenuTagSection === tag.megaMenuTagSection
					) === index
			);
			const closedMenuTagsUpdated = [...closedMenuSaleTags, id];

			state.closedMenuSaleTags = closedMenuTagsUpdated;

			if (
				visibleTagsOnMegaMenu.every((tag) =>
					closedMenuTagsUpdated.includes(tag.id)
				)
			) {
				state.showMegaMenuIndicator = false;
				localStorage.setItem(
					LS_DOT_MEGAMENU_HIDDEN_AT,
					JSON.stringify(hiddenAt)
				);
				state.closedMenuSaleTags = [];
			}
		}
	},
	extraReducers: (builder) => {
		builder.addCase(getSaleTags.fulfilled, (state, action) => {
			const saleTags = action.payload;
			if (saleTags) {
				state.saleTags = sortByPriority(saleTags);
			}
		});
	}
});

export const {
	closeStickyTag,
	hideHamburgerDot,
	showHamburgerDot,
	setActiveTags
} = stickySaleTagSlice.actions;
// prettier-ignore
export const selectStickySaleTagState = (state: RootState) => state.stickySaleTag;
export default stickySaleTagSlice.reducer;
export * from "./types";
export * from "./thunks";
